function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#348C30;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M419,168.1H258.7c-19.9,0-36.1,16.2-36.1,36.1v46.1V334c0,10.1-7.6,19.1-17.6,19.7c-10.8,0.6-19.6-8-19.6-18.6 v-167h-37.3v230.8H419V168.1z"
});

var SvgOxyAdministrativo = function SvgOxyAdministrativo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.9 566.9",
    style: {
      enableBackground: "new 0 0 566.9 566.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOxyAdministrativo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/oxy-administrativo.ef1b5bbf.svg";
export { ForwardRef as ReactComponent };